import { render } from "./vip-detail.vue?vue&type=template&id=75986e34&scoped=true"
import script from "./vip-detail.vue?vue&type=script&lang=js"
export * from "./vip-detail.vue?vue&type=script&lang=js"

import "./vip-detail.vue?vue&type=style&index=0&id=75986e34&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75986e34"]])

export default __exports__